import React, { useState, useCallback } from 'react';
import axios from 'services/axios';
import { Link, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import Button from 'components/atoms/Button';
import FormInput from 'components/atoms/FormInput';
import Spinner from 'components/atoms/Spinner';
import showPwd from '../../../assets/svg/show.svg';
import hidePwd from '../../../assets/svg/hide.svg';
import Alert from 'components/atoms/Alert';
import { handleException } from 'utils';
import { connect } from 'react-redux';


const Login = ({ }) => {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');

	const [emailErr, setEmailErr] = useState('');
	const [passwordErr, setPasswordErr] = useState('');

	const [fetchStatus, setFetchStatus] = useState('');

	const [loading, setLoading] = useState(false);
	const [submitLoading, setSubmitLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [errorState, setErrorState] = useState(false);

	const [newPassword, setNewPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [bearerToken, setBearerToken] = useState('');

	const navigate = useNavigate();
	const formComplete = email !== '' && newPassword !== '';
	const disabledBtn = formComplete === false || loading === true;

	const params = useParams();


	const getTokenDetails = async () => {
		try {
			setLoading(true);
			const res = await axios.post(
				`https://pocket.seerbitapi.com/pocket/verify-onboarding`,
				{ hashedOtp: params?.onboardToken },
				{
					headers: {
						'Content-Type': 'application/json',
					},
				}
			);

			if (res.data.data.success) {
				const userEmail = res.data.data.email;
				setEmail(userEmail);

				// Generate bearer token for the complete-onboarding call
				const tokenRes = await axios.post(
					`https://pocket.seerbitapi.com/pocket/authenticate/generate/${userEmail}`,
					{},
					{ headers: { 'Content-Type': 'application/json' } }
				);
				setBearerToken(tokenRes.data.data.token);
				setLoading(false);
				Alert('success', res.data.message);
			} else {
				setLoading(false);
				window.location.href = '/auth/login';
			}
		} catch (error) {
			setLoading(false);
			setErrorState(true);
			handleException(error);
		}
	};

	const submitDetails = async (e) => {
		e.preventDefault();
		try {
			if (!newPassword || !confirmPassword || !email) {
				Alert('error', 'Incomplete Form data input');
				return;
			}

			if (newPassword !== confirmPassword) {
				Alert('error', 'Password do not Match');
				return;
			}
			setSubmitLoading(true);
			const res = await axios.post(
				`https://pocket.seerbitapi.com/pocket/user/complete-onboarding`,
				{ hashedOtp: params?.onboardToken, emailAddress: email, newPassword },
				{
					headers: {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${bearerToken}`,
					},
				}
			);

			if (res.data.data) {
				setSubmitLoading(false);
				Alert('success', res.data.message);
				setTimeout(() => { window.location.href = '/auth/login'; }, 2000);
			} else {
				setSubmitLoading(false);
				Alert('error', res.data.message);
				// window.location.href = '/auth/login';
			}
		} catch (error) {
			setSubmitLoading(false);
			setErrorState(true);
			handleException(error);
		}
	};

	React.useEffect(() => {
		getTokenDetails();
	}, [params]);

	return !loading ? (
		<>
			<form onSubmit={submitDetails}>
				<p className="font-semibold text-2xl leading-7 text-Black2">
					Get Started
				</p>
				<span className="text-left flex flex-col gap-5 mb-5">
					<p className="font-normal text-base leading-7">
						Welcome!!!, please enter your details
					</p>
				</span>
				<span className="flex flex-col gap-3">
					<FormInput
						type="email"
						name="email"
						placeholder="example@gmail.com"
						inputStyle="border border-transparent text-Black2"
						label="Email Address"
						labelStyle="font-normal text-base leading-6 text-Black2"
						onChange={(e) => setEmail(e.target.value)}
						value={email}
						validationErr={emailErr}
						disabled
					/>
					<FormInput
						type={showPassword ? 'text' : 'password'}
						name="passwd"
						placeholder="********"
						inputStyle="border border-transparent text-Black2 flex-row-reverse"
						label="New Password"
						labelStyle="font-normal text-base leading-6 text-Black2"
						onChange={(e) => setNewPassword(e.target.value)}
						value={newPassword}
						validationErr={passwordErr}
						img={showPassword ? showPwd : hidePwd}
						imgStyle="cursor-pointer w-5 h-5 block"
						imgOnClick={() => setShowPassword((prevState) => !prevState)}
					/>
				</span>
				<span>
					<FormInput
						type={showPassword ? 'text' : 'password'}
						name="passwd"
						placeholder="********"
						inputStyle="border border-transparent text-Black2 flex-row-reverse"
						label="Confirm Password"
						labelStyle="font-normal text-left text-Black2 mx-0 mt-6"
						onChange={(e) => setConfirmPassword(e.target.value)}
						value={confirmPassword}
						validationErr={passwordErr}
						img={showPassword ? showPwd : hidePwd}
						imgStyle="cursor-pointer w-5 h-5 block"
						imgOnClick={() => setShowPassword((prevState) => !prevState)}
					/>
				</span>
				<span>
					<Button
						btnType="submit"
						btnText={
							submitLoading
								? // <Spinner/>      // <Spinner text="Loading..." textStyle="text-white" />
								'Loading...'
								: 'Sign Up'
						}
						btnStyle={`${disabledBtn ? 'cursor-not-allowed' : ''
							} bg-black text-white px-6 py-3 mt-12 w-full`}
						disabled={formComplete === false || submitLoading}
					/>
				</span>
			</form>
		</>
	) : (
		<div className="flex gap-4 items-center">
			<Spinner /> <p>Loading....</p>
		</div>
	);
};

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
